import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostFilter = _resolveComponent("PostFilter")!
  const _component_SkeletonGrid = _resolveComponent("SkeletonGrid")!
  const _component_PostGrid = _resolveComponent("PostGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PostFilter, {
      categories: _ctx.categories,
      "current-category": _ctx.currentCategory,
      onCategoryChanged: _ctx.onCategoryChanged
    }, null, 8, ["categories", "current-category", "onCategoryChanged"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_SkeletonGrid, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_PostGrid, {
          key: 1,
          posts: _ctx.posts
        }, null, 8, ["posts"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, {
      to: "#work2",
      disabled: !_ctx.posts2?.length
    }, [
      _createVNode(_component_PostGrid, { posts: _ctx.posts2 }, null, 8, ["posts"])
    ], 8, ["disabled"])),
    (_openBlock(), _createBlock(_Teleport, {
      to: "#work3",
      disabled: !_ctx.posts3?.length
    }, [
      _createVNode(_component_PostGrid, { posts: _ctx.posts3 }, null, 8, ["posts"])
    ], 8, ["disabled"]))
  ], 64))
}